import http from "@/utils/request"

export default {
	agent: {
		list: async function (data = {}) {
			return await http.get("agent/list", data);
		},
		info: async function (data = {}) {
			return await http.get("agent/info", data);
		},
		add: async function (data = {}) {
			return await http.post("agent/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("agent/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("agent/del", data);
		},
		option: async function (data = {}) {
			return await http.get("agent/option", data);
		},
	},
	merchant: {
		list: async function (data = {}) {
			return await http.get("merchant/list", data);
		},
		info: async function (data = {}) {
			return await http.get("merchant/info", data);
		},
		add: async function (data = {}) {
			return await http.post("merchant/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("merchant/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("merchant/del", data);
		},
		option: async function (data = {}) {
			return await http.get("merchant/option", data);
		},
		rateList: async function (data = {}) {
			return await http.get("merchant/rate/list", data);
		},
		queryConfig: async function (data = {}) {
			return await http.get("merchant_channel/config/query", data);
		},
		saveConfig: async function (data = {}) {
			return await http.post("merchant_channel/config/save", data);
		},
		queryReceiverConfig: async function (data = {}) {
			return await http.get("merchant_receiver/config/query", data);
		},
		saveReceiverConfig: async function (data = {}) {
			return await http.post("merchant_receiver/config/save", data);
		},
	},
	channel: {
		list: async function (data = {}) {
			return await http.get("channel/list", data);
		},
		info: async function (data = {}) {
			return await http.get("channel/info", data);
		},
		add: async function (data = {}) {
			return await http.post("channel/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("channel/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("channel/del", data);
		},
		option: async function (data = {}) {
			return await http.get("channel/option", data);
		},
	},
	merchant_apply: {
		list: async function (data = {}) {
			return await http.get("merchant_apply/list", data);
		},
		info: async function (data = {}) {
			return await http.get("merchant_apply/info", data);
		},
		add: async function (data = {}) {
			return await http.post("merchant_apply/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("merchant_apply/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("merchant_apply/del", data);
		},
		option: async function (data = {}) {
			return await http.get("merchant_apply/option", data);
		},
	},
	agent_channel: {
		list: async function (data = {}) {
			return await http.get("agent_channel/list", data);
		},
		info: async function (data = {}) {
			return await http.get("agent_channel/info", data);
		},
		rate: async function (data = {}) {
			return await http.get("agent_channel/rate", data);
		},
		add: async function (data = {}) {
			return await http.post("agent_channel/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("agent_channel/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("agent_channel/del", data);
		}
	},
	merchant_channel: {
		list: async function (data = {}) {
			return await http.get("merchant_channel/list", data);
		},
		info: async function (data = {}) {
			return await http.get("merchant_channel/info", data);
		},
		rate: async function (data = {}) {
			return await http.get("merchant_channel/rate", data);
		},
		add: async function (data = {}) {
			return await http.post("merchant_channel/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("merchant_channel/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("merchant_channel/del", data);
		},
		option: async function (data = {}) {
			return await http.get("merchant_channel/option", data);
		},
		queryConfig: async function (data = {}) {
			return await http.get("channel/default_rule", data);
		},
		saveConfig: async function (data = {}) {
			return await http.post("channel/default_rule", data);
		},
	},
	split: {
		prepare: async function (data = {}) {
			return await http.post("split/prepare", data);
		},
		open: async function (data = {}) {
			return await http.post("split/open", data);
		},
		signQuery: async function (data = {}) {
			return await http.post("split/sign/query", data);
		},
	},
	merchant_receiver: {
		list: async function (data = {}) {
			return await http.get("merchant_receiver/list", data);
		},
		info: async function (data = {}) {
			return await http.get("merchant_receiver/info", data);
		},
		add: async function (data = {}) {
			return await http.post("merchant_receiver/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("merchant_receiver/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("merchant_receiver/del", data);
		},
		option: async function (data = {}) {
			return await http.get("merchant_receiver/option", data);
		},
	},
	receiver_config: {
		list: async function (data = {}) {
			return await http.get("receiver_config/list", data);
		},
		add: async function (data = {}) {
			return await http.post("receiver_config/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("receiver_config/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("receiver_config/del", data);
		},
		option: async function (data = {}) {
			return await http.get("receiver_config/option", data);
		},
	},
	receiver_rule: {
		list: async function (data = {}) {
			return await http.get("receiver_rule/list", data);
		},
		add: async function (data = {}) {
			return await http.post("receiver_rule/add", data);
		},
		edit: async function (data = {}) {
			return await http.put("receiver_rule/edit", data);
		},
		del: async function (data = {}) {
			return await http.delete("receiver_rule/del", data);
		},
		option: async function (data = {}) {
			return await http.get("receiver_rule/option", data);
		},
	},
	report: {
		wx: async function (data = {}) {
			return await http.get("report/wx", data);
		},
		zfb: async function (data = {}) {
			return await http.get("report/zfb", data);
		},
		sync: async function (data = {}) {
			return await http.post("report/sync", data);
		},
		wechatConfig: async function (data = {}) {
			return await http.get("report/wechat/config", data);
		},
		wechatBind: async function (data = {}) {
			return await http.post("report/wechat/bind", data);
		},
	},
	ident: {
		wx: async function (data = {}) {
			return await http.get("ident/wx", data);
		},
		zfb: async function (data = {}) {
			return await http.get("ident/zfb", data);
		},
		apply: async function (data = {}) {
			return await http.post("ident/apply", data);
		},
		sync: async function (data = {}) {
			return await http.post("ident/sync", data);
		},
		cancel: async function (data = {}) {
			return await http.post("ident/cancel", data);
		},
	},
	merchant_change: {
		info: async function (data = {}) {
			return await http.get("merchant_change/info", data);
		},
		edit: async function (data = {}) {
			return await http.put("merchant_change/edit", data);
		},
	}
}
